import { createContext } from "react";
import axios, { AxiosError, AxiosInstance } from "axios";

import { login, setRedirect } from "./auth";

export const HttpClientContext = createContext<AxiosInstance | null>(
  createClient(null)
);

const X_API_TOKEN = "x-api-token";

export function createClient(token: string | null) {
  if (token === null) return null;

  const client = axios.create({
    headers: {
      [X_API_TOKEN]: token,
    },
  });

  client.interceptors.response.use(undefined, (error: AxiosError) => {
    if (error.response?.status === 401) {
      setRedirect(window.location.pathname);
      return login();
    }

    return Promise.reject(error);
  });

  return client;
}

export const X_REQUEST_ID = "x-request-id";
